import { render, staticRenderFns } from "./InspectionErrorsModal.vue?vue&type=template&id=56085202&scoped=true&"
import script from "./InspectionErrorsModal.vue?vue&type=script&lang=js&"
export * from "./InspectionErrorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56085202",
  null
  
)

export default component.exports